import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useTranslation } from 'react-i18next'

export const useInterconnectedApps = () => {
  const { t } = useTranslation()
  const { apps } = useAvailableApps()

  return {
    personalTourApps: [
      {
        icon: apps[AppId.TIMETRACKING].appIcon || apps[AppId.TIMETRACKING].icon,
        name: apps[AppId.TIMETRACKING].name,
        illustrationUrl: apps[AppId.TIMETRACKING].illustrationUrl,
        description: t('appsList.timetracking.tourDescription_personal'),
        tags: t('appsList.timetracking.tags_personal', {
          returnObjects: true
        })
      },
      {
        icon:
          apps[AppId.TASK_MANAGEMENT].appIcon ||
          apps[AppId.TASK_MANAGEMENT].icon,
        name: apps[AppId.TASK_MANAGEMENT].name,
        illustrationUrl: apps[AppId.TASK_MANAGEMENT].illustrationUrl,
        description: t('appsList.taskManagement.tourDescription_personal'),
        tags: t('appsList.taskManagement.tags_personal', {
          returnObjects: true
        })
      },
      {
        icon: apps[AppId.CLUSTER_DOCS].appIcon || apps[AppId.CLUSTER_DOCS].icon,
        name: apps[AppId.CLUSTER_DOCS].name,
        illustrationUrl: apps[AppId.CLUSTER_DOCS].illustrationUrl,
        description: t('appsList.clusterDoc.tourDescription_personal'),
        tags: t('appsList.clusterDoc.tags_personal', {
          returnObjects: true
        })
      },
      {
        icon:
          apps[AppId.CLUSTER_FILES].appIcon || apps[AppId.CLUSTER_FILES].icon,
        name: apps[AppId.CLUSTER_FILES].name,
        illustrationUrl: apps[AppId.CLUSTER_FILES].illustrationUrl,
        description: t('appsList.documents.tourDescription_personal'),
        tags: t('appsList.documents.tags_personal', {
          returnObjects: true
        })
      }
    ],
    organizationTourApps: [
      {
        icon: apps[AppId.HR].appIcon || apps[AppId.HR].icon,
        name: apps[AppId.HR].name,
        illustrationUrl: apps[AppId.HR].illustrationUrl,
        description: t('appsList.hr.tourDescription_organization'),
        tags: t('appsList.hr.tags_organization', {
          returnObjects: true
        })
      },
      {
        icon:
          apps[AppId.TASK_MANAGEMENT].appIcon ||
          apps[AppId.TASK_MANAGEMENT].icon,
        name: apps[AppId.TASK_MANAGEMENT].name,
        illustrationUrl: apps[AppId.TASK_MANAGEMENT].illustrationUrl,
        description: t('appsList.taskManagement.tourDescription_organization'),
        tags: t('appsList.taskManagement.tags_organization', {
          returnObjects: true
        })
      },
      {
        icon:
          apps[AppId.PROJECT_MANAGEMENT].appIcon ||
          apps[AppId.PROJECT_MANAGEMENT].icon,
        name: apps[AppId.PROJECT_MANAGEMENT].name,
        illustrationUrl: apps[AppId.PROJECT_MANAGEMENT].illustrationUrl,
        description: t(
          'appsList.project-management.tourDescription_organization'
        ),
        tags: t('appsList.project-management.tags_organization', {
          returnObjects: true
        })
      },
      {
        icon: apps[AppId.CLUSTER_DOCS].appIcon || apps[AppId.CLUSTER_DOCS].icon,
        name: apps[AppId.CLUSTER_DOCS].name,
        illustrationUrl: apps[AppId.CLUSTER_DOCS].illustrationUrl,
        description: t('appsList.documents.tourDescription_organization'),
        tags: t('appsList.documents.tags_organization', {
          returnObjects: true
        })
      }
    ]
  }
}
